import type { CollectionContract } from '@/data/schema/contract'
import type { ContractItem } from '@/data/schema/contract-item'

/**
 * Format a date string into a human readable format
 * @param date
 * @returns
 */
export function formatDate(date: string): string {
	return typeof date === 'string' ? new Date(date).toLocaleDateString('en-gb') : 'Invalid date'
}

/**
 * Bulk format contract dates
 * @param items Contract[]
 */
export function formatContractDates(items: CollectionContract[]) {
	return items.map((item) => ({
		...item,
		delivery_date: formatDate(item.delivery_date ?? ''),
		collection_date: formatDate(item.collection_date ?? ''),
		journey_date: formatDate(item.journey_date ?? '')
	}))
}

/**
 * Bulk format contract items dates
 * @param items ContractItem[]
 * @returns ContractItem[]
 */
export function formatItemsDates(items: ContractItem[]): ContractItem[] {
	return items.map((item) => ({
		...item,
		delivery_date: formatDate(item.delivery_date),
		collection_date: formatDate(item.collection_date)
	}))
}

/**
 * YYYY-MM-DD a date
 * @param date
 * @returns string
 */
export function YMD(date: Date) {
	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, '0')
	const day = String(date.getDate()).padStart(2, '0')
	return `${year}-${month}-${day}`
}

/**
 * Compare two dates
 * @param first
 * @param second
 */
export function compareDates(first: Date, second: Date) {
	return first.setHours(0, 0, 0, 0).toString() == second.setHours(0, 0, 0, 0).toString()
}
